// export function select<T, K>()

import { distinctUntilChanged, map, OperatorFunction, pipe } from 'rxjs';

export function select<T, R>(project: (value: T) => R): OperatorFunction<T, R> {
  return pipe(
    map(project),
    distinctUntilChanged()
  );
}
